// выбор корректного значения для ElectrikDriveType
export const getElectrikDriveTypeValue = (electrikDriveType = null) => {
  if (!electrikDriveType) return;
  if (!Array.isArray(electrikDriveType.options_values)) return;
  const list = electrikDriveType.options_values;

  const value3 = list.find(el => String(el.value) === '3');
  if (value3) {
    return value3;
  }

  const value9 = list.find(el => String(el.value) === '9');

  if (value9) {
    return value9;
  }

  const value28 = list.find(el => String(el.value) === '28');

  if (value28) {
    return value28;
  }

  return;
};

export const getTubeOptions = ({ tube = null, isElectrikKit = false, options = [] }) => {
  if (tube?.option_default && isElectrikKit) {
    const tubeValue = tube.options_values.find(el => el.id === tube.option_default);

    if (tubeValue) {
      const tubeDiameterExactly = tubeValue.name.replace(/[^\d]/g, '');

      const options_electric_kit = options.filter(
        el =>
          (el.is_default === 1 && !el.value) ||
          (tubeDiameterExactly &&
            el.name.replace('Д/Н', '').match(new RegExp(tubeDiameterExactly + '\\s*\\('))),
      );

      if (options_electric_kit.length > 1) {
        return options_electric_kit;
      } else {
        return [];
      }
    }
  } else if (tube && !tube.option_default && isElectrikKit) {
    return [];
  }

  return;
};

// сортировка поле messages в ответе от /calculate
export const getCalculateMessages = (list = []) => {
  const currentList = Array.isArray(list) ? list : [];

  return currentList.sort(a => (a?.type === 'error' ? -1 : 0));
};

// сортировка поля messages в зависимости от поля agree
export const getMessagesFilter = ({ list = [], agree = false }) => {
  if (agree) {
    // показываем все кроме warning && is_warranty !== (0 | null)
    return list.filter(
      ({ type = '', is_warranty = null }) =>
        type !== 'warning' || (type === 'warning' && is_warranty === 1),
    );
  }

  return list;
};
